import React, {useEffect, useState, useRef, useContext} from "react";
import OlMap from 'ol/Map';
import OlView from 'ol/View';
import {TileWMS, Vector as VectorSource, Cluster, XYZ, OSM} from 'ol/source';
import {Tile as TileLayer, Vector as VectorLayer, Group as LayerGroup} from 'ol/layer';
import OlProj from 'ol/proj/Projection';
import OlFormatGeoJSON from 'ol/format/GeoJSON';
import {format} from 'ol/coordinate';
import OlLayerGroup from 'ol/layer/Group';

import {Circle as CircleStyle, Fill, Stroke, Style, Text, Icon} from 'ol/style';
import { config } from '../../config';
import { authenticationService } from '../../services';



import BicycleParkingSpotInfo from "../../components/BicycleParkingSpotInfo";

import { Modal, message, Tree, Button, Row, Col, Drawer, Space, Carousel, Avatar, Form, Input, Select, TimePicker, Switch } from 'antd';
import proj4 from 'proj4';
import { register } from 'ol/proj/proj4.js';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import {reverseGeocode, useInterval} from '../../helpers';
import "cropperjs/dist/cropper.min.css";


import AppHeading from "../../components/AppHeading";

import 'moment/locale/hr';
import 'ol/ol.css';

import './Home.css';

import {
    MapComponent,
} from '@terrestris/react-geo';

import AppMenu from "../../components/AppMenu";
import SurveyViewer from "../../components/SurveyViewer";
import {locateMe} from "../../helpers/locationHelper";
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import { UserContext } from "../../contexts/UserContext";
import { CheckPathname } from "../../helpers";
import { createWMSLayer, createPointLayer, HtrsExtents } from '../../helpers/mapHelpers'


import obrnuti_u from './images/icons/green_marker/obrnuti_u_v6.png'
import { toLonLat, transform } from "ol/proj";




const { Option } = Select;


proj4.defs('EPSG:3765', "+proj=tmerc +lat_0=0 +lon_0=16.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs");
register(proj4);
const bicycle_parking_supply_user = createPointLayer('ciklopark:bicycle_parking_supply_user', 'bicycle_parking_supply_user', [obrnuti_u, 1], 'type',true);
const bicycle_parking_demand_user = createPointLayer('ciklopark:bicycle_parking_demand_user ', 'bicycle_parking_demand_user', [obrnuti_u, 1], 'type',true);
const JLS = createWMSLayer('JLS','ciklopark:geo_jls_group', true);

const osm = new TileLayer({ 
  name: 'Open Street Map',
  visible: true,
  source: new OSM({attributions: '<a class="copyright" href="https://www.openstreetmap.org/copyright" target="_blank">OSM</a>'}),
  zIndex:0
});

const hoverLayer = new VectorLayer({
	name: 'HoverLines',
	source: new VectorSource(),
	style: new Style({
		stroke: new Stroke({
			color: 'red',
			width: 4,
			lineCap : 'square',
			lineJoin: 'bevel'
		})
	}),
	zIndex: 25,
	metadata: "hover"
});

function selectStyleFunction(feature, resolution) {
	let style;
	if (feature.getGeometry().getType() == 'Point') {
		let symbol = feature.get('symbolDefinition');
		if (Array.isArray(symbol)){
			style = new Style({
				image: new Icon({
					crossOrigin: 'anonymous',
					//imgSize: [20, 20],
					src:symbol[0],
					scale: symbol[1],				
					color:'yellow',
					anchor: [0.5, 1],
          			anchorXUnits: 'fraction',
          			anchorYUnits: 'fraction',
				}),
			});
		}
	} else {
		//MultiLineString
		style = new Style({
			stroke: new Stroke({
				color: 'yellow',
				width: 4,
				lineCap : 'square',
				lineJoin: 'bevel',
				anchor: [0.5, 1],
          		anchorXUnits: 'fraction',
          		anchorYUnits: 'fraction',
			}),
		});
	}

	return style;
}

const selectLayer = new VectorLayer({
	name: 'SelectLines',
	source: new VectorSource(),
	style: selectStyleFunction,
	zIndex: 32,//26,
	metadata: "select"
});


let extents=HtrsExtents();
let centerCoordinates = [(extents[0]+extents[2])/2,(extents[1]+extents[3])/2];

export const Home = (props) => {
	const {setLocation, location} = useContext(UserContext)
	const [showSupplySurvey, setShowSupplySurvey] = useState(false)
	const [showDemandSurvey, setShowDemandSurvey] = useState(false)
	
	const showSupplySurveyRef = useRef(false)
	const showDemandSurveyRef = useRef(false)
	
	// Utility
	const [showImageVisible, setShowImageVisible] = useState(false);
	const [showBicycleParkingVisible, setShowBicycleParkingVisible] = useState(false);
	const [isFetchingSourceData, setIsFetchingSourceData] = useState(true);
	const [maskDrawerInfo, setMaskDrawerInfo] = useState(true);
	const key = 'updatable';

	const [hasMoreData, setHasMoreData] = useState(false);
	const [currentImages, setCurrentImages] = useState(false);
	const [loading, setLoading] = useState(false);
	const [page, setPage] = useState(1);
	const [take, setTake] = useState(50);
	const [surveyLoadingScreen, setSurveyLoadingScreen] = useState(false);

	// Data
	const [selectedBicycleParkingSpot, setSelectedBicycleParkingSpot] = useState(null);
 
	// Sources
	const sourceHover = hoverLayer.getSource();
	const sourceSelect = selectLayer.getSource();

	let sourceBicycleParking_supply_user = bicycle_parking_supply_user.getSource();
	let sourceBicycleParking_demand_user = bicycle_parking_demand_user.getSource();

	// Features

	const [featuresBicycleParking_supply_user, setFeaturesBicycleParking_supply_user] = useState(null);
	const [featuresBicycleParking_demand_user, setFeaturesBicycleParking_demand_user] = useState(null);
	const showLocator = useRef(false)
	const [mapMoving, setMapMoving] = useState(false)

	// Refs
	const [form] = Form.useForm();
	const mapRef = useRef();
	//const dofRef = useRef();
	const drawRef = useRef();
	const sketchRef = useRef();
	const listenerRef = useRef(); 
	
	const pathnameCheck=CheckPathname();
	
	// Slojevi
	const RegisterGroupTiles = new OlLayerGroup({
		name: 'Registar prostornih jedinica',
		layers: [
				JLS
		].filter(n => n)
	});



	//setVisibility(false)
	const layerGroupTiles = new OlLayerGroup({
		name: 'LayerGroupTiles',
		layers: [RegisterGroupTiles.getLayers().getArray().length > 0 && RegisterGroupTiles,
		].filter(n => n)
	});

	//Kartografske podloge
	const publicGroupTiles = new OlLayerGroup({
		name: 'Javne',
		layers: [
			osm
		].filter(n => n)
	});
/* dok se geo ne slozi	
	const officialGroupTiles = new OlLayerGroup({
		name: 'Službene',
		layers:[
			new OlLayerGroup({
				name:'DOF5_2019_2020',
				layers: [
					DOF5_2019_2020,
					DOF5_2011_FILL_2019_2020]
			})
		].filter(n => n)
	});
*/
	const mapGroupTiles = new OlLayerGroup({
		name: 'MapGroupTiles',
		layers: [
			publicGroupTiles,
			// dok se geo ne slozi	officialGroupTiles
		].filter(n => n)
	});

	const routesTiles = new OlLayerGroup({
		name: 'Cikloturističke rute',
		layers: [
			bicycle_parking_supply_user,
			bicycle_parking_demand_user
		].filter(n => n)
	});
	
	
	const groupLines = new OlLayerGroup({
		name: 'Cikloturističke rute, odmorišta, servisne postaje, restorani',
		layers: [
			routesTiles.getLayers().getArray().length > 0 && routesTiles,	
		].filter(n => n)
	});
	
	const mercProj = new OlProj({
		code: "EPSG:900913"
	})

	const proj = new OlProj({
		code: 'EPSG:3765',
		units: 'm',
		global: false
	});
	

	const map = new OlMap({
        view: new OlView({
			center:centerCoordinates,// [498134, 4925214],
			projection: proj,
			zoom: 8,
			enableRotation: false,
        	maxZoom: 24,
       		minZoom: 7
        }),
        layers: [
			mapGroupTiles,
			layerGroupTiles,
			groupLines.getLayers().getArray().length > 0 && groupLines,
			hoverLayer,
			selectLayer,
		].filter(n => n)
	});

	//apply(map, 'https://api.maptiler.com/maps/basic-v2/style.json?key=PXozRJubuZMcE1tHsdVw');
	
	useEffect(() => {
		if(loading) {
			message.loading({ content: 'Učitavanje...', key });
		}
		else {
			message.success({ content: 'Učitano!', key, duration: 2 });
			navigator&&navigator.permissions&&navigator.permissions.query({name:'geolocation'}).then((result) => {
				if (result.state === 'granted') {
					showLocation()
				} else if (result.state === 'prompt') {
					map.getView().fit(extents,{padding: [100, 10, 10, 10]});
				}
					// Don't do anything if the permission was denied.
			})||map.getView().fit(extents,{padding: [100, 10, 10, 10]});
		}
	}, [loading])

	useEffect(() => {
		if(!authenticationService.getUser()) {
			authenticationService.loginAnonymous()
			sourceBicycleParking_supply_user = bicycle_parking_supply_user.getSource();
			sourceBicycleParking_demand_user = bicycle_parking_demand_user.getSource();
		}
	}, [])

	

	// Buffer features
	useInterval(() => {
		if(!featuresBicycleParking_supply_user || featuresBicycleParking_supply_user.length == 0) {
			const data = sourceBicycleParking_supply_user.getFeatures();
			if(data && data.length > 0) {
				setFeaturesBicycleParking_supply_user(data);
			}
		}
		if(!featuresBicycleParking_demand_user || featuresBicycleParking_demand_user.length == 0) {
			const data = sourceBicycleParking_demand_user.getFeatures();
			if(data && data.length > 0) {
				setFeaturesBicycleParking_demand_user(data);
			}
		}
		if(featuresBicycleParking_supply_user &&
				featuresBicycleParking_demand_user ) {
			if(featuresBicycleParking_supply_user.length > 0 &&
				featuresBicycleParking_demand_user.length>0) {
				setIsFetchingSourceData(false)
			}
		}
	}, isFetchingSourceData ? 300 : null);

	// Initial component load
	React.useEffect(() => {
		mapRef.current = map;
		const fetchData = async() => {

			try {
				setLoading(true);
				// temp fix await getRoutes({routeTypes: null, elementTypes: null, locations: null, page: 1, take: 10});
			}
			finally {
				setLoading(false);
			}
			
		}
		fetchData();
		refreshAllSources();
	}, [])


	const pointerMoveHandler = (evt) => {
		if (evt.dragging) {
			return;
		}

		sourceHover.clear();
		document.getElementById('MousePosition').innerHTML = format(map.getCoordinateFromPixel(evt.pixel), "{x}, {y}", 2);

		map.getTargetElement().style.cursor = map.hasFeatureAtPixel(evt.pixel) ? 'pointer' : '';

        const hoveredFeatures = map.getFeaturesAtPixel(evt.pixel, {
            layerFilter: function(layer) {
                return [
					bicycle_parking_supply_user,
					bicycle_parking_demand_user
				].filter(n => n).includes(layer);
            }
		});

		if(hoveredFeatures && hoveredFeatures.length > 0) {
			try {
				for (let i = 0; i < hoveredFeatures.length; i++) {
					sourceHover.addFeature(hoveredFeatures[i]);
				}
			}
			catch {}
		}

	
	};

	
	

	map.on('pointermove', pointerMoveHandler);
	map.on('singleclick', async (e) => {

		setSelectedBicycleParkingSpot(null);
		sourceSelect.clear();
		sourceHover.clear();

        const selectedFeatures = map.getFeaturesAtPixel(e.pixel, {
            layerFilter: function(layer) {
                return [
					bicycle_parking_supply_user,
					bicycle_parking_demand_user
				].filter(n => n).includes(layer);
            }
		});
		

		//ovo je za clustere select,rekao bi da mogu napraviti da se ucita		
		setShowBicycleParkingVisible(false);
	    if(selectedFeatures.length > 0) {
            const existingFeatures = selectedFeatures[0].get('features');
				//console.log("Selected features:", selectedFeatures[0].id_)
					let bicycleParking = selectedFeatures.map((i)=>
					({id: i.values_['id'], type: i.values_['type'], details: JSON.parse(i.values_['details']),typeOfRequest:i.id_.split('.')[0]}))
					{JSON.parse(localStorage.getItem("ciklopark_current_user")).type==1&&console.log(bicycleParking)}
				if(bicycleParking) {
					setSelectedBicycleParkingSpot(bicycleParking);
					setShowBicycleParkingVisible(true);
					}				
				sourceSelect.addFeature(selectedFeatures[0]);
			
		}
	});

	const manuallySetLocation = async () =>{
		sourceSelect.clear();	
		showLocator.current = true
		setMapMoving(true)
	}

	map.on('movestart', () => {
		if(showSupplySurveyRef.current){return}
		else if(showDemandSurveyRef.current){return}
		else{
		setMapMoving(true)
		}
	});

	map.on('moveend', () => {
		if(showSupplySurveyRef.current){setMapMoving(false)}
		else if(showDemandSurveyRef.current){setMapMoving(false)}
		else{
		if(map && showLocator.current) {
			const center = transform(
				map.getView().getCenter(),
				map.getView().getProjection(),
				mercProj
			)
			const latLong = toLonLat(center)
			reverseGeocode({latitude: latLong[1], longitude: latLong[0]}, setLocation)
			{JSON.parse(localStorage.getItem("ciklopark_current_user")).type==1&&console.log("select ST_Transform(ST_GeomFromText('POINT (",latLong[0],latLong[1],")',4326),3765)",)}
		}
		setMapMoving(false)}
	});


	const refreshAllSources = () => {
		try {
			sourceBicycleParking_supply_user && sourceBicycleParking_supply_user.addFeatures(featuresBicycleParking_supply_user);
		}
		catch {}
		try {
			sourceBicycleParking_demand_user && sourceBicycleParking_demand_user.addFeatures(featuresBicycleParking_demand_user);
		}
		catch {}
		
		
	}

	const refreshAfterCompletedSurvey = () => {		
		try {
			sourceBicycleParking_supply_user.refresh();		
			sourceBicycleParking_supply_user = bicycle_parking_supply_user.getSource().setUrl(`${config.geoserverUrl}/ows?service=WFS&version=1.0.0&request=GetFeature&`+
			'typename=' + 'ciklopark:bicycle_parking_supply_user' + '&outputFormat=application/json'+				
			 `&CQL_FILTER=(token='${authenticationService.getUser()?.accessToken}'or(verified=1))`)
		}
		catch {
			console.log("Failed to refresh")
		}
		try {
			sourceBicycleParking_demand_user.refresh();
			sourceBicycleParking_demand_user = bicycle_parking_demand_user.getSource().setUrl(`${config.geoserverUrl}/ows?service=WFS&version=1.0.0&request=GetFeature&`+
			'typename=' + 'ciklopark:bicycle_parking_demand_user' + '&outputFormat=application/json'+				
			 `&CQL_FILTER=(token='${authenticationService.getUser()?.accessToken}')or(verified=1)`)

		}
		catch {
			console.log("Failed to refresh")
		}
		
		
	}
       
const handleShowImage = (images) => {
		setCurrentImages(images);
		setShowImageVisible(!showImageVisible);
	}
	const bicycleParkingSpotTitle = selectedBicycleParkingSpot && ( 
		
		selectedBicycleParkingSpot[0].type == "ponuda" && <div>Postojeća ponuda</div> ||
		selectedBicycleParkingSpot[0].type == "potražnja" && <div>Postojeća potražnja</div>
	) || "";



	const [isNotificationVisible, setIsNotificationVisible] = React.useState(() => {
		const showNotification = sessionStorage.getItem("showNotification");
		return JSON.parse(showNotification) ?? true;
	  });

	  React.useEffect(() => {
		sessionStorage.setItem("showNotification", JSON.stringify(isNotificationVisible));
	  }, [isNotificationVisible]);


	const hideNotification = () => {
		setIsNotificationVisible(false);
	  };

	const toggleSupplySurvey = () => {	
		if(!location) {
			alert("Za unos ponude potrebna nam je vaša lokacije")
			return
		}	
		else if(!showLocator.current&&!showSupplySurvey) {				
			setSurveyLoadingScreen(true)		
			showLocation();
		}
		setShowSupplySurvey(!showSupplySurvey)
		showLocator.current = false
		showSupplySurveyRef.current = !showSupplySurvey
	}
	
	const toggleDemandSurvey = () => {
		if(!location) {
			alert("Za unos potražnje potrebna nam je vaša lokacije")
			return
		}
		else if(!showLocator.current&&!showDemandSurvey) {
			setSurveyLoadingScreen(true)
			showLocation()			
		}
		setShowDemandSurvey(!showDemandSurvey)
		showLocator.current = false
		showDemandSurveyRef.current=!showDemandSurvey
	}

	const toggleShowBicycleParkingSpotInfo = () => {
		setShowBicycleParkingVisible(!showBicycleParkingVisible)
	}

	const showLocation = async () =>{
		showLocator.current = false
		await locateMe(map, mapRef, sourceSelect, setLocation,setSurveyLoadingScreen)
	}

	// useEffect(() => {
	// 	if(showDemandSurvey || showSupplySurvey) {
	// 		showLocation()
	// 	}
	// }, [showDemandSurvey, showSupplySurvey])

	const handleCloseSurvey = (onClose) => () => {
		refreshAfterCompletedSurvey()
		onClose()
	}


    return (
        <>

			<BrowserView>
			<Modal visible={isNotificationVisible} footer={null} title="Važna napomena:" onCancel={hideNotification}>
				<p style={{fontSize:"17px"}}>Web aplikacija za prijavu biciklističke parkirališne ponude i potražnje razvijena je isključivo za
					unos podataka mobilnim ili tablet uređajima.</p>
				<p style={{fontSize:"17px"}}>
					Projektne rezultate pratite na WebGIS Platformi Nacionalne baze biciklističke parkirališne
					ponude i potražnje. </p>
				<a style={{fontSize:"17px", color:"#ccba78"}} href="https://cikloparking.academica.hr/app/nationaldatabase">
				https://cikloparking.academica.hr/app/nationaldatabase
				</a>
			</Modal>
			</BrowserView>


            <MapComponent
				map={map}
				ref={mapRef}
            />
			<AppHeading
			hasLogout={pathnameCheck.logoutStatus}			
			>
			</AppHeading>
  
			
			<MobileView>
			<AppMenu 
				onEnterSupply={toggleSupplySurvey} 
				onEnterDemand={toggleDemandSurvey} 
				onLocate={showLocation}
				onManualLocate={manuallySetLocation}
				showDemandButton={pathnameCheck.showDemandButton}
				
			/>
			</MobileView>
			{/* 
			<AppMenu 
				///privremeni ostavljeno za testiranje
				onEnterSupply={toggleSupplySurvey} 
				onEnterDemand={toggleDemandSurvey} 
				onLocate={showLocation}
				showDemandButton={pathnameCheck.showDemandButton}
			/>
		*/}
			<div id = "MousePosition" style={{position: 'fixed', bottom: 2, right: 50, color: 'black'}}></div>
			
			{showLocator.current && (
				<div className="locator" ><i className={`ri-map-pin-fill ${mapMoving && "locator-moving" || ""}`}></i></div>
			)}
			
	
			<SurveyViewer visible={showDemandSurvey} bigSurvey={false} surveyLoading={surveyLoadingScreen} onClose={handleCloseSurvey(toggleDemandSurvey)} surveyId={4} />
			<SurveyViewer visible={showSupplySurvey} bigSurvey={false} surveyLoading={surveyLoadingScreen} onClose={handleCloseSurvey(toggleSupplySurvey)} surveyId={pathnameCheck.surveyID} />

			
			<Drawer
                title={bicycleParkingSpotTitle}
                width="600px"
				destroyOnClose={true}
				className={`bicycleParkingSpot-modal`}
				placement="right"	
                closable={true}
				mask={false}
				onClose={toggleShowBicycleParkingSpotInfo}
                onCancel={toggleShowBicycleParkingSpotInfo}
                visible={showBicycleParkingVisible}
				footer={null}
            >
				
				<BicycleParkingSpotInfo 
					bicycleParkingSpot={selectedBicycleParkingSpot}
					showImages={handleShowImage} 
				/>
			</Drawer>

        </>
    );
}
